<template>
  <naj-modal
    ref="fullScreenModal"
    :header="false"
    :width="1200"
    :footer="true"
    :show-footer-close-button="true"
    @onClose="modalClose"
    @keydown.prevent="
      () => {
        return;
      }
    "
  >
    <div
      v-if="fileUrl"
      class="attachment-file-viewer"
    >
      <image-editor
        v-if="isImage"
        :image-url="fileUrl"
        :image-name="attachment.name"
        :preview-mode="true"
      ></image-editor>

      <div
        v-else
        class="pdf-container"
      >
        <embed
          class="pdf-viewer"
          :src="fileUrl"
        >
      </div>
    </div>
  </naj-modal>
</template>

<script>
import ImageEditor from './image-editor';
import { attachmentType } from '@/helpers/enum';
import { getBlobUrl } from '@/modules/lawsuit/helpers/utils';

export default {
  name: 'FullScreenAttachment',
  components: { ImageEditor },
  props: {
    attachment: {
      type: Object,
      required: true,
    },
    visibility: {
      type: Boolean,
      required: true,
    },
    isImage: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return { attachmentType };
  },
  computed: {
    fileUrl() {
      return getBlobUrl(this.attachment.fileUrl, this.isImage);
    },
  },
  watch: {
    visibility(newValue) {
      const fullScreenModal = this.$refs.fullScreenModal;
      newValue ? fullScreenModal.show() : fullScreenModal.close();
    },
  },
  methods: {
    modalClose() {
      this.$emit('onClose');
    },
  },
};
</script>

<style lang="scss" scoped>
.attachment-file-viewer {
  display: flex;
  justify-content: center;
  height: 600px;
}
.pdf-container {
  position: relative;
  overflow: hidden;
  width: 100%;
  .pdf-viewer {
    height: 100%;
    width: 100%;
    display: inline-block;
  }
  .pdf-actions {
    text-align: center;
    padding: 20px 0;
  }
}
</style>
